/** Save flows that open {@link updateCigNoteConfirmationDialog}. */
export type UpdateCigNoteConfirmationSource =
  | "j_codes"
  | "cig_notes"
  | "documents"
  | "cpt_codes";

/**
 * Returns the modal title for the update confirmation dialog.
 *
 * @param source - Which save flow opened the dialog
 * @param tableLength - Number of linked sibling orders shown in the table
 * @returns Dialog header text
 */
export const getUpdateCigNoteConfirmationDialogTitle = (
  source: UpdateCigNoteConfirmationSource,
  tableLength: number,
): string => {
  if (tableLength > 0) {
    return "Update Linked Orders";
  }

  switch (source) {
    case "j_codes":
      return "J-Codes Update Confirmation";
    case "cig_notes":
      return "Note Update Confirmation";
    case "documents":
      return "Document Update Confirmation";
    case "cpt_codes":
      return "CPT Codes Update Confirmation";
  }
};
